<template>
  <div v-if="isLoading" class="flex justify-center p-10" :class="variantClasses.frame">
    <SpinnerComp class="h-8!" />
  </div>

  <div v-else-if="isEmpty" class="p-10 text-center" :class="variantClasses.frame">
    <p class="text-sm text-gray-500">{{ emptyMessage }}</p>
  </div>

  <template v-else>
    <div v-if="groups.today.length > 0" :class="[variantClasses.frame, variantClasses.padding]">
      <span
        class="mb-2 inline-block rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-500"
        :class="variantClasses.label"
      >
        Today
      </span>
      <div class="divide-y divide-gray-200">
        <NotificationItem
          v-for="notification in groups.today"
          :key="notification.id"
          :notification="notification"
        />
      </div>
    </div>

    <div
      v-if="groups.older.length > 0"
      :class="[variantClasses.frame, variantClasses.padding, { 'mt-4': groups.today.length > 0 }]"
    >
      <span
        class="mb-2 inline-block rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-500"
        :class="variantClasses.label"
      >
        Older
      </span>
      <div class="divide-y divide-gray-200">
        <NotificationItem
          v-for="notification in groups.older"
          :key="notification.id"
          :notification="notification"
        />
      </div>
    </div>
  </template>
</template>

<script setup>
import { computed } from 'vue'
import NotificationItem from './NotificationItem.vue'
import SpinnerComp from '@/components/SpinnerComp.vue'

const VARIANT_CLASSES = {
  card: {
    frame: 'rounded-lg border border-gray-200 bg-white',
    padding: 'p-4',
    label: ''
  },
  flat: {
    frame: '',
    padding: '',
    label: 'ml-3'
  }
}

const props = defineProps({
  groups: {
    type: Object,
    required: true
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  emptyMessage: {
    type: String,
    default: "You're all caught up. New activity will show up here."
  },
  variant: {
    type: String,
    default: 'card',
    validator: (value) => ['card', 'flat'].includes(value)
  }
})

const isEmpty = computed(() => props.groups.today.length === 0 && props.groups.older.length === 0)
const variantClasses = computed(() => VARIANT_CLASSES[props.variant])
</script>
